import React from 'react';
import Divider from '@mui/material/Divider';

export function FabDivider() {
  return <Divider sx={{ mb: 2 }} />;
}
